import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface CampaignLite {
  code: string;
  campaign_type: string;
  title: string;
  description: string;
  reward_minor: number;
}

interface Props {
  campaigns: CampaignLite[];
  open: boolean;
  onClose: () => void;
  onContinue: (code: string | null) => void;
}

export function BonusSelectSheet({ campaigns, open, onClose, onContinue }: Props) {
  const { t } = useTranslation(['common', 'nav']);
  const [selected, setSelected] = useState<string | null>(null);

  useEffect(() => {
    if (open && campaigns[0]) setSelected(campaigns[0].code);
  }, [open, campaigns]);

  if (!open) return null;

  return (
    <div className="sheet-backdrop" role="presentation" onClick={onClose}>
      <div
        className="sheet-panel bonus-select-sheet"
        role="dialog"
        aria-modal="true"
        aria-label={t('common:bonusSelectTitle')}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sheet-grab" aria-hidden="true" />
        <h2>{t('common:bonusSelectTitle')}</h2>
        <div className="bonus-select-list">
          {campaigns.length === 0 ? (
            <p className="muted-note">{t('common:promoFallbackSubtitle')}</p>
          ) : (
            campaigns.slice(0, 4).map((c) => (
              <button
                key={c.code}
                type="button"
                className={`bonus-select-card${selected === c.code ? ' active' : ''}`}
                onClick={() => setSelected(c.code)}
              >
                <div>
                  <strong>{c.title}</strong>
                  <span className="muted-note">{c.campaign_type}</span>
                  <p>{c.description}</p>
                </div>
                <span className="radio-dot" aria-hidden="true" />
              </button>
            ))
          )}
        </div>
        <button type="button" className="btn btn-primary btn-block" onClick={() => onContinue(selected)}>
          {t('common:continue', { defaultValue: 'Continue' })}
        </button>
      </div>
    </div>
  );
}
